import { Fragment } from "react";

import useIsGoStudentLearningApp from "features/goStudentLearning/hooks/useIsGoStudentLearningApp";
import { useIsPlurallApp } from "features/plurall";

import SignInCardGoStudentLearning from "../apps/SignInCardGoStudentLearning";
import SignInCardPlurallApp from "../apps/SignInCardPlurallApp";
import SignInCardStandard from "../apps/SignInCardStandard";

export type SignInCardAppsContainerProps = {
  linkToSignUp: string;
  linkToPasswordReset: string;
  redirectAuthenticatedUserTo?: string;
};

export default function SignInCardContainer(
  props: SignInCardAppsContainerProps
) {
  const isPlurallApp = useIsPlurallApp();
  const isGoStudentLearningApp = useIsGoStudentLearningApp();

  return (
    <Fragment>
      {isGoStudentLearningApp ? (
        <SignInCardGoStudentLearning {...props} />
      ) : isPlurallApp ? (
        <SignInCardPlurallApp {...props} />
      ) : (
        <SignInCardStandard {...props} />
      )}
    </Fragment>
  );
}
